if (!customElements.get('au-header-mega')) {
  customElements.define('au-header-mega', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.desktop = window.matchMedia('(min-width: 992px)');
      this.trigger = this.querySelector('[data-mega-trigger]');
      this.toggle = this.querySelector('[data-mega-toggle]');
      this.panel = this.querySelector('[data-mega-panel]');
      const on = (target, event, callback) => target.addEventListener(event, callback, { signal: this.abort.signal });
      on(this, 'pointerenter', (event) => {
        if (event.pointerType !== 'touch') { this.blockFocusOpen = false; this.open(); }
      });
      on(this, 'pointerleave', () => this.scheduleClose());
      on(this, 'focusin', () => { if (!this.blockFocusOpen) this.open(); });
      on(this, 'focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.blockFocusOpen = false;
        this.scheduleClose();
      });
      on(this.toggle, 'pointerdown', () => { this.toggleWasOpen = !this.panel.hidden; });
      on(this.toggle, 'click', () => {
        if (this.toggleWasOpen === false || this.panel.hidden) this.open(); else this.close();
        this.toggleWasOpen = null;
      });
      on(this.trigger, 'click', (event) => {
        if (!this.desktop.matches) return;
        if (!this.trigger.getAttribute('href') || this.trigger.getAttribute('href') === '#') {
          event.preventDefault();
          if (this.panel.hidden) this.open(); else this.close();
        }
      });
      on(document, 'pointerdown', (event) => { if (!this.contains(event.target)) this.close(); });
      on(document, 'pointerover', (event) => {
        const otherItem = event.target.closest('.nav--lv1');
        if (otherItem && !otherItem.contains(this)) this.close();
      });
      on(document, 'keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          const restoreFocus = this.contains(document.activeElement);
          this.blockFocusOpen = true;
          this.close();
          if (restoreFocus) this.trigger.focus();
        }
      });
      on(window, 'resize', () => { if (!this.desktop.matches) this.close(); else this.queuePosition(); });
      on(window, 'scroll', () => this.queuePosition());
      on(document, 'shopify:block:select', (event) => { if (this.contains(event.target)) this.open(); });
      on(document, 'shopify:block:deselect', (event) => { if (this.contains(event.target)) this.close(); });
      if (typeof ResizeObserver !== 'undefined') {
        this.headerObserver = new ResizeObserver(() => this.queuePosition());
        document.querySelectorAll('.site-header .header-content, #header-sticky').forEach((row) => this.headerObserver.observe(row));
      }
      this.queuePosition();
    }

    position() {
      if (this.panel.hidden) return;
      const row = this.closest('.header-search__parent');
      const bottom = row ? row.getBoundingClientRect().bottom : this.getBoundingClientRect().bottom;
      if (bottom <= 0) {
        this.close();
        return;
      }
      this.panel.style.setProperty('--au-mega-top', `${Math.max(0, bottom)}px`);
    }

    queuePosition() {
      if (this.positionFrame || this.panel.hidden) return;
      this.positionFrame = requestAnimationFrame(() => {
        this.positionFrame = null;
        this.position();
      });
    }

    open() {
      clearTimeout(this.closeTimer);
      if (!this.desktop.matches) return;
      document.querySelectorAll('au-header-mega').forEach((menu) => { if (menu !== this && menu.panel) menu.close(); });
      this.panel.hidden = false;
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.position();
      this.queuePosition();
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (!this.matches(':hover') && !this.contains(document.activeElement)) this.close();
      }, 200);
    }

    close() {
      clearTimeout(this.closeTimer);
      this.panel.hidden = true;
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-expanded', 'false');
    }

    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.positionFrame);
      this.positionFrame = null;
      this.headerObserver?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
